module.exports = __webpack_public_path__ + "img/brandmark.dcce5718.svg";